import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "input__label-wrapper"
}
const _hoisted_2 = ["for"]
const _hoisted_3 = ["aria-label", "onClick"]
const _hoisted_4 = ["id", "value", "type", "readonly", "placeholder", "aria-invalid", "aria-describedby"]
const _hoisted_5 = ["id"]

import { computed, useId } from "vue";
import Modal from "@shared/Components/Modal/Modal.vue";
import { getTranslations } from "@shared/Services/translations";


export default /*@__PURE__*/_defineComponent({
  __name: 'Input',
  props: {
    modelValue: {},
    type: { default: "text" },
    placeholder: { default: "" },
    rootClassModifier: { default: "" },
    label: {},
    id: {},
    isInvalid: { type: Boolean, default: false },
    readOnly: { type: Boolean, default: false },
    infoHeading: { default: "" },
    infoContent: { default: "" },
    unit: { default: "" },
    errorMessage: {}
  },
  emits: ["update:modelValue", "input", "blur"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const translations = getTranslations();
const infoButtonAriaLabel = computed(() => {
  const infoButtonText = translations["bookings.common.openinformation"] ?? "Open information";
  const subject = props.infoHeading || props.label;

  return subject ? `${infoButtonText}: ${subject}` : infoButtonText;
});

const generatedId = useId();
const inputId = computed(() => props.id || generatedId);
const errorId = computed(() => `${inputId.value}-error`);
const currentErrorMessage = computed(() => props.errorMessage?.trim() ?? "");
const hasErrorMessage = computed(() => currentErrorMessage.value.length > 0);
const isFieldInvalid = computed(() => props.isInvalid || hasErrorMessage.value);
const describedBy = computed(() => (hasErrorMessage.value ? errorId.value : undefined));

const onInput = (event: Event) => {
  const target = event.target as HTMLInputElement;
  emit("update:modelValue", target.value);
  emit("input", target.value);
};

const onBlur = () => {
  emit("blur");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["input", props.rootClassModifier])
  }, [
    (props.label || props.infoHeading || props.infoContent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (props.label)
            ? (_openBlock(), _createElementBlock("label", {
                key: 0,
                class: "label",
                for: inputId.value
              }, _toDisplayString(props.label), 9 /* TEXT, PROPS */, _hoisted_2))
            : _createCommentVNode("v-if", true),
          (props.infoHeading || props.infoContent)
            ? (_openBlock(), _createBlock(Modal, {
                key: 1,
                heading: props.infoHeading,
                content: props.infoContent
              }, {
                link: _withCtx(({ clicked }) => [
                  _createElementVNode("button", {
                    class: "input__info-icon info-icon",
                    type: "button",
                    "aria-label": infoButtonAriaLabel.value,
                    onClick: clicked
                  }, "?", 8 /* PROPS */, _hoisted_3)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["heading", "content"]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", {
      class: _normalizeClass(['input-group', { 'input-group--has-addon': !!props.unit }])
    }, [
      _createElementVNode("input", {
        class: _normalizeClass(["input__field input-group__input-field", [
          { 'input__field--invalid': isFieldInvalid.value },
          { 'input-group__input-field--invalid': isFieldInvalid.value },
          { 'input-group__input-field--read-only': props.readOnly },
        ]]),
        id: inputId.value,
        value: props.modelValue,
        type: props.type,
        readonly: props.readOnly,
        placeholder: props.placeholder,
        "aria-invalid": isFieldInvalid.value || undefined,
        "aria-describedby": describedBy.value,
        onInput: onInput,
        onBlur: onBlur
      }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_4),
      (props.unit)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(["input-group__input-field-addon", [
          { 'input-group__input-field-addon--invalid': __props.isInvalid },
          { 'input-group__input-field-addon--read-only': props.readOnly },
        ]])
          }, _toDisplayString(props.unit), 3 /* TEXT, CLASS */))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */),
    (hasErrorMessage.value)
      ? (_openBlock(), _createElementBlock("p", {
          key: 1,
          id: errorId.value,
          class: "input__error",
          "aria-live": "polite"
        }, _toDisplayString(currentErrorMessage.value), 9 /* TEXT, PROPS */, _hoisted_5))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}
}

})